import React from "react";
import LoadingLoginScreen from "../../components/LoadingLoginScreen";
import { getAllUsers } from "../../services/AdminService";
import { AdminUserGrid } from "./AdminUsers/AdminUserGrid";
import {Container} from "react-bootstrap";

export const AdminUserDashboard = () => {
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false)

    const fetchAllUsers = React.useCallback(async () => {
        try {
            setLoading(true);

            const allUsers = await getAllUsers();

            setUsers(allUsers);
            setLoading(false);
        } catch {

        }
    })

    React.useEffect(() => {
        fetchAllUsers();
    }, []);

    return (
        <React.Fragment>
            {loading ? <LoadingLoginScreen /> :
                <Container>
                    <AdminUserGrid users={users} />
                </Container>
            }
        </React.Fragment>
    )
}
